export default "__VITE_ASSET__BlHFv1zN__"